import { render } from "./ButtonUserAnalytics.vue?vue&type=template&id=6ec2dee8"
import script from "./ButtonUserAnalytics.vue?vue&type=script&lang=js"
export * from "./ButtonUserAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__